import {BehaviorSubject} from 'rxjs';
import {map, distinctUntilChanged} from 'rxjs/operators';

export const innerWidth$ = new BehaviorSubject(1200);
export const innerHeight$ = new BehaviorSubject(768);
export const isMobileSize$ = new BehaviorSubject(false);
export const aspectRatio$ = innerWidth$.pipe(
  map((innerWidth) => {
    return Math.max(Math.min(innerWidth, 1920), 1280) / 1920;
  })
);

innerWidth$
  .pipe(
    map((size) => size < 640),
    distinctUntilChanged()
  )
  .subscribe((isMobileSize) => {
    isMobileSize$.next(isMobileSize);
  });
